import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { handleStudentId } from "../redux/slice/StudentDetailSlice";
import { Trash, UserRoundSearch } from "lucide-react";
import { activeComponentValue } from "../redux/slice/ActiveComponentSlice";
import api from "../utils/api";
function StudentList({ studentList, classId }) {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const handleStudent = (studentId) => {
    dispatch(handleStudentId(studentId));
    navigate("/studentDetail");
  };

  const handleDelete = async (classId, studentId) => {
    try {
      const res = await api.delete("deleteStudentByClass", {
        params: { classId, studentId },
      });
      if (res.status === 200) {
        dispatch(activeComponentValue(3));
        navigate("/routePage");
      }
    } catch (error) {
      console.error(error, "silme işlemi başarısız");
    }
  };
  const students = studentList?.students || studentList || [];

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider">
                Ad Soyad
              </th>
              <th className="px-6 py-4 text-center text-sm font-semibold text-gray-700 uppercase tracking-wider">
                E-posta
              </th>
              <th className="px-6 py-4 text-center text-sm font-semibold text-gray-700 uppercase tracking-wider">
                Ödev Durumu
              </th>
              <th className="px-6 py-4 text-center text-sm font-semibold text-gray-700 uppercase tracking-wider">
                Başarı Oranı
              </th>
              <th className="px-6 py-4 text-center text-sm font-semibold text-gray-700 uppercase tracking-wider">
                İşlemler
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {students.map((student, index) => {
              // Ödev durumu verisi yoksa varsayılan değerler
              const homework = student.homework || "0/0";
              const [completed, total] = homework.split("/").map(Number);
              const percentage = total > 0 ? (completed / total) * 100 : 0;

              return (
                <tr
                  key={student._id || index}
                  className="hover:bg-gray-50 transition-colors duration-200"
                >
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="flex-shrink-0 h-10 w-10">
                        <div
                          className="h-10 w-10 rounded-full bg-purple-500 flex items-center
                         justify-center text-white font-semibold"
                        >
                          {student.username?.charAt(0) || "Ö"}
                        </div>
                      </div>
                      <div className="ml-4">
                        <div className="text-sm font-medium text-gray-900">
                          {student.username || "İsim"}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-center">
                    <div className="text-sm text-gray-900">
                      {student.email || "E-posta yok"}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-center">
                    <div className="text-sm font-semibold text-gray-900"></div>
                    <div className="text-xs text-gray-500">
                      tamamlanan/toplam
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-center">
                    <div className="flex items-center justify-center">
                      <div className="w-16 bg-gray-200 rounded-full h-2 mr-2">
                        <div
                          className="bg-gradient-to-r from-green-400 to-green-600 
                          h-2 rounded-full transition-all duration-300"
                          style={{ width: `${percentage}%` }}
                        ></div>
                      </div>
                      <span className="text-sm font-semibold text-gray-700">
                        {percentage.toFixed(0)}%
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-center">
                    <div className="flex gap-2 justify-center">
                      <button
                        className="bg-purple-500 w-18 h-10 rounded-lg text-white hover:bg-purple-600 
                        flex justify-center items-center gap-1 p-1 transition-colors"
                        onClick={() => handleStudent(student._id)}
                      >
                        <UserRoundSearch className="w-4 h-4" />
                        <span className="font-normal text-sm">Detay</span>
                      </button>
                      <button
                        className="bg-red-500 w-20 h-10 rounded-lg text-white
                         hover:bg-red-600 flex justify-center items-center gap-1 p-1 transition-colors"
                        onClick={() => handleDelete(classId, student._id)}
                      >
                        <Trash className="w-4 h-4" />
                        <span className="font-normal text-sm">Sil</span>
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default StudentList;
